import React from 'react'
import { LoadableCard } from '~/components/commons'
import { NavItem } from 'reactstrap'
import * as Styles from './styles'
import { FormattedMessage } from 'react-intl'
import IntegrationCard from '../IntegrationCard'
import { useIntegrations } from '../../contexts/integrations.context'
import EmptyBoxSvg from '~/components/EmptyBoxSvg'
import Pagination from '~/components/Pagination'

const getCount = count => {
  if (!count) return null
  if (count === 0) return null
  if (count > 99) return '99+'
  return `${count}`
}
export default function IntegrationList() {
  const {
    currentTab,
    handleTab,
    isLoading,
    integrations,
    totalPages,
    noContent,
    count,
    totalItems,
  } = useIntegrations()

  return (
    <LoadableCard className="p-3" loading={isLoading}>
      <Styles.Container>
        <Styles.Title>
          <FormattedMessage id="Integrations" />
        </Styles.Title>
        <Styles.Nav tabs className={'integration-list'}>
          {['All', 'Pending', 'Linked', 'Divergence'].map(tab => (
            <NavItem
              data-active={currentTab === tab.toLowerCase()}
              key={tab}
              id={tab.toLowerCase()}
              onClick={() => {
                handleTab(tab.toLowerCase())
              }}
            >
              <FormattedMessage id={tab} />
              {Boolean(count?.[tab.toLocaleLowerCase()]) && (
                <div className="count">
                  <span>{getCount(count?.[tab.toLocaleLowerCase()])}</span>
                </div>
              )}
            </NavItem>
          ))}
        </Styles.Nav>
        {noContent ? (
          <>
            <Styles.NoContentWrapper>
              <EmptyBoxSvg />
              <span>
                <FormattedMessage id={`noContent.integration.${currentTab}`} />
              </span>
            </Styles.NoContentWrapper>
          </>
        ) : (
          <>
            <Styles.TabContent>
              {integrations &&
                integrations.map(integration => (
                  <IntegrationCard
                    key={integration.id}
                    data={integration.nissei}
                    type={integration.match}
                    locationId={integration.google?.id}
                    integrationId={integration.nissei?.id}
                    linkId={integration.id}
                  />
                ))}
            </Styles.TabContent>
            <Pagination
              totalItems={totalItems}
              totalPages={totalPages}
              prefix={'integration'}
            >
              <Pagination.Limit />
              <Pagination.Pages />
            </Pagination>
          </>
        )}
      </Styles.Container>
    </LoadableCard>
  )
}
